import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DemoProjects from './DemoProjects';

const ProjectsIn = () => {

    const [project] = useState(DemoProjects)
    return (
        <>
            <div className="dgn">
                {
                    project.map(x => <ProjectsInn X={x} />)
                }
            </div>
        </>
    );
};

export default ProjectsIn;

const ProjectsInn = ({ X }) => {
    const handleClick = () => {
        window.scrollTo(0, 0)

    }
    const { id, name, image, description, technology, live, client, backend } = X;

    return (
        <>

            <div className="dg-inn">
                <img src={image} width="100%" alt="" />
                <div className="asdp">
                     <h1>{name}</h1>
                <Link  to={`/details/${id}`} onClick={handleClick}> <button className="btne" style={{ cursor: 'pointer' }}>view Details</button></Link>
                </div>
               
            </div>
        </>
    );
};
